import { useCallback, useEffect, useState } from "react";
import {
  getSearchNews,
  getSearchArticles,
} from "../../services/news/news.service";
import styles from "./Search.module.css";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import Heading from "../../components/heading/heading";
import Title from "../../components/title";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSearchProducts } from "../../services/product/product.service";
import ProductListItem from "../../components/product/ProductListItem";
import NewsBar from "../../components/product/NewsBar";
import AttachmentHome from "../../components/AttachmentHome";

const Search = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  let [query, setQuery] = useState("");
  let [news, setNews] = useState([]);
  let [products, setProducts] = useState([]);
  let [articles, setArticles] = useState([]);
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  let [pLoading, setPloading] = useState(true);
  let [nLoading, setNloading] = useState(true);
  let [aLoading, setAloading] = useState(true);

  const hangleSearchCallback = useCallback(() => {
    const querySearch = searchParams.get("q");
    if (
      /^[\u0600-\u06FFa-zA-Z0-9-_.،\s]+$/.test(querySearch) &&
      querySearch.indexOf('"') < 0 &&
      querySearch.indexOf("'") < 0
    ) {
      setQuery(querySearch);
      const tempQuery = querySearch;
      if (tempQuery === null) {
        navigate("/");
      } else {
        setNloading(true);
        getSearchNews(0, tempQuery).then(({ data }) => {
          setNloading(false);
          setNews(data.data.data);
        });
        setAloading(true);
        getSearchArticles(tempQuery).then(({ data }) => {
          setAloading(false);
          setArticles(data.data);
        });
        setPloading(true);
        getSearchProducts(0, tempQuery).then(({ data }) => {
          setPloading(false);
          if (data && data.data) {
            setProducts(data.data.data);
          }
        });
      }
      setBreadCrumbItems([
        { title: "خانه", url: "/" },
        { title: "جستجو", url: "/search?q=" + tempQuery },
      ]);
    } else {
      navigate(-1);
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    hangleSearchCallback();
  }, [hangleSearchCallback]);
  const goToNews = (e) => {
    e.preventDefault();
    navigate("/news/list");
  };
  return (
    <>
      <Title title={`جستجو : ${query}`} />
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <BreadCrumb items={breadCrumbItems} />
            <div className="clearfix"></div>
          </div>
          <div className={"clearfix"}></div>

          <div id={styles.newsListBox} className={"clearfix"}>
            <div className={"col-xs-12 col-md-12 pull-right"}>
              <Heading title={"نتایج اخبار "} />
              <div id={styles.newsListWrapper}>
                {!nLoading ? (
                  news.length > 0 ? (
                    news.map((item, key) => {
                      return (
                        <div className="col-xs-12 col-md-12 pull-right">
                          <NewsBar key={key + "-product-bar"} news={item} />
                        </div>
                      );
                    })
                  ) : (
                    <div className={"result-not-found"}>خبری یافت نشد</div>
                  )
                ) : (
                  <div className="loading-wrapper">
                    <img
                      src={"../../../assets/image/loading.svg"}
                      alt={"در حال بار گذاری"}
                    />
                  </div>
                )}
              </div>
              <div className="clearfix"></div>
              <button className={styles.loadMoreElems} onClick={goToNews}>
                بیشتر ...
              </button>
              <div className="clearfix"></div>
              {Array.isArray(articles) && articles.length > 0 ? (
                <>
                  <Heading title={"نتایج مقاله"} />
                  <div id={styles.newsListWrapper2}>
                    <div className={"row"}>
                      <ul className={styles.newsListStyle}>
                        {!aLoading ? (
                          articles.length > 0 ? (
                            articles.map((item, key) => (
                              <li
                                key={key + "-articles"}
                                className={"col-xs-12 col-md-12"}
                              >
                                <div>
                                  <a
                                    rel="noreferrer"
                                    className={styles.newsElem}
                                    download={"download"}
                                    href={item.file_ref}
                                    target={"_blank"}
                                  >
                                    {item.title}
                                    <span> . {item.publish_date}</span>
                                  </a>
                                </div>
                              </li>
                            ))
                          ) : (
                            <div className={"col-xs-12 result-not-found"}>
                              مقاله ای یافت نشد
                            </div>
                          )
                        ) : (
                          <div className="loading-wrapper">
                            <img
                              src={"../../../assets/image/loading.svg"}
                              alt={"در حال بار گذاری"}
                            />
                          </div>
                        )}
                      </ul>
                    </div>
                    <Heading title={"جستجوی محصولات"} />
                    <div className="row">
                      {!pLoading ? (
                        products.length > 0 ? (
                          products.map((item, key) => {
                            return (
                              <div
                                key={`product-${item.id}`}
                                className="col-xs-12 col-md-6 pull-right"
                              >
                                <ProductListItem
                                  key={key + "-product-bar"}
                                  item={item}
                                />
                              </div>
                            );
                          })
                        ) : (
                          <div className={"col-xs-12 result-not-found"}>
                            محصولی یافت نشد
                          </div>
                        )
                      ) : (
                        <div className="loading-wrapper">
                          <img
                            src={"../../../assets/image/loading.svg"}
                            alt={"در حال بار گذاری"}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className={"clearfix"}></div>
          </div>
          <div className={"clearfix"}></div>
        </div>
      </div>
    </>
  );
};

export default Search;
